module.exports = __webpack_public_path__ + "img/906867_C7B6BC_5D2E26_BEA4A3-256px.f4cda409.png";